<template>
  <div id="app" style="overflow: hidden">
    <router-view />
    <!-- <div class="landscape_warning" v-if="isTablet">
      <img src="./assets/images/rotate_notice.png" />
      <p class="rotate_text">请旋转至横屏</p>
    </div> -->
  </div>
</template>

<script>
  import { vhPageStylePostMessage } from '@/app-shared/utils/common.js';
  import { useMsgServer } from 'middle-domain';
  import { $unifiedMessage } from '@/app-shared/utils/unifiedMessage';
  export default {
    data() {
      return {
        // isTablet: window.isTablet
      };
    },
    methods: {
      loaded() {
        // console.log('页面全部加载完成');
        vhPageStylePostMessage();
      },
      timNetStateChangeHandler(state) {
        console.log('网络变化，timNetStateChangeHandler：', state);
        if (state === 'disconnected') {
          $unifiedMessage({
            message: '当前网络不可用',
            showClose: true,
            position: 'center',
            duration: 0,
            type: 'error'
          });
        } else if (state === 'connecting') {
          $unifiedMessage({
            message: '网络连接中...',
            showClose: true,
            position: 'center',
            duration: 0,
            type: 'warning'
          });
        } else if (state === 'connected') {
          $unifiedMessage.clear();
        }
      },
      unloadHandler(event) {
        this.msgServer?.destroy(false); // 主动调用退出tim
      },
      handlePageHide(event) {
        if (!event.persisted) {
          // 事件触发 (无persisted) - 页面刷新或关闭
          this.msgServer?.destroy(false); // 主动调用退出tim
        }
      }
    },
    beforeCreate() {
      this.msgServer = useMsgServer();
    },
    mounted() {
      window.addEventListener('load', this.loaded);
      // 监听浏览器tab刷新或关闭事件
      window.addEventListener('beforeunload', this.unloadHandler);
      window.addEventListener('pagehide', this.handlePageHide);
      this.msgServer.$on('onTimNetStateChange', this.timNetStateChangeHandler);
    },
    beforeDestroy() {
      window.removeEventListener('load', this.loaded);
      window.removeEventListener('beforeunload', this.unloadHandler);
      window.removeEventListener('pagehide', this.handlePageHide);
      this.msgServer.$off('onTimNetStateChange', this.timNetStateChangeHandler);
    }
  };
</script>
<style lang="less">
  // .landscape_warning {
  //   display: none;
  // }
  // @media (orientation: portrait) {
  //   .landscape_warning {
  //     position: fixed;
  //     display: flex;
  //     flex-direction: column;
  //     align-items: center;
  //     justify-content: center;
  //     top: 0;
  //     left: 0;
  //     width: 100%;
  //     height: 100%;
  //     background-color: rgba(255, 255, 255, 0.9);
  //     z-index: 9999;
  //     text-align: center;
  //     img {
  //       width: 260px;
  //     }
  //     .rotate_text {
  //       font-size: 24px;
  //       color: #333;
  //       margin-top: 10px;
  //     }
  //   }
  // }
</style>
